import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { SectionHeader } from "./SectionHeader";

export const Writings = ({ writings, settings }) => (
  <section id="writings" className="relative py-28 md:py-36" data-testid="writings-section">
    <div className="section-shell">
      <SectionHeader
        index="03"
        overline="Essays & Threads"
        title="Writings & Media"
        description="Longer-form thinking on Substack and working notes on X — the connective tissue between the papers."
      />

      <div className="divide-y divide-white/10 border-y border-white/10">
        {writings.map((w, i) => (
          <Reveal key={w.id || w.title} delay={i * 0.05}>
            <a
              href={w.externalUrl}
              target="_blank"
              rel="noreferrer"
              className="group flex flex-col gap-4 py-8 transition-colors duration-300 hover:bg-white/[0.02] md:flex-row md:items-center md:justify-between"
              data-testid={`writing-${i}`}
            >
              <div className="flex items-start gap-6 md:items-center">
                <span className="mt-1 w-20 shrink-0 font-mono text-[10px] uppercase tracking-widest text-plasma-teal/70 md:mt-0">
                  {w.sourceType}
                </span>
                <div>
                  <h3 className="font-display text-2xl md:text-3xl font-light leading-tight text-white transition-colors group-hover:text-plasma-teal">
                    {w.title}
                  </h3>
                  <p className="mt-2 max-w-2xl font-sans text-sm font-light text-slate-400">{w.summary}</p>
                </div>
              </div>
              <div className="flex items-center gap-4 pl-24 md:pl-0">
                <span className="font-mono text-xs text-slate-500">{w.publishDate}</span>
                <ArrowUpRight className="h-5 w-5 text-slate-500 transition-all duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 group-hover:text-plasma-teal" strokeWidth={1.5} />
              </div>
            </a>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1} className="mt-10 flex flex-wrap gap-5">
        <a href={settings?.socialLinks?.substack} target="_blank" rel="noreferrer" className="btn-plasma" data-testid="writings-substack">
          All essays on Substack <ArrowUpRight className="h-4 w-4" strokeWidth={1.5} />
        </a>
        <a href={settings?.socialLinks?.x} target="_blank" rel="noreferrer" className="btn-gold" data-testid="writings-x">
          Follow on X <ArrowUpRight className="h-3.5 w-3.5" strokeWidth={1.5} />
        </a>
      </Reveal>
    </div>
  </section>
);
